import { OPEN_AI_STATUS_URL, SUPPORT_EMAIL } from "constants/config";
import useLabels from "hooks/useLabels";
import Link from "next/link";

interface PropsType {
  error?: string;
}
function StreamingError({ error }: PropsType) {
  const [errorLabels] = useLabels("error");

  const isOpenAiError = error && error.includes("OpenAI API errored out");

  return (
    <div className="flex flex-col p-4 text-sm rounded-lg gap-y-2 bg-chart-red-faint">
      {isOpenAiError ? (
        <>
          <></>
          <h2 className="sm-md">{errorLabels["open-ai-error-title"]}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: errorLabels["open-ai-error-msg"].replace(
                "OPEN_AI_STATUS_URL",
                OPEN_AI_STATUS_URL
              ),
            }}
          ></p>
        </>
      ) : (
        <>
          <h2 className="sm-md">{errorLabels["title"]}</h2>
          <p>
            {errorLabels["description"]}
            <Link className="underline" href={"mailto:" + SUPPORT_EMAIL}>
              {`${SUPPORT_EMAIL}.`}
            </Link>
          </p>
        </>
      )}
    </div>
  );
}

export default StreamingError;
